<template>
	<div v-loading="loading">
		<div class="flex" style="margin-bottom: 10px;"><el-button type="primary" @click="addManageGroup">添加管理员组</el-button></div>
		<el-table
			:data="manageGroupList"
			style="width: 100%;margin-bottom: 20px;"
			row-key="id"
			border
			:stripe="true"
			:default-sort="{ prop: 'ctime', order: 'ascending' }"
			@sort-change="sortChange"
		>
			<el-table-column prop="id" label="管理组ID" width="80"></el-table-column>
			<el-table-column prop="name" label="管理组名"></el-table-column>
			<el-table-column prop="ctime" label="添加时间" sortable></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="changeMenu(scope.row)">菜单权限</el-button>
					<el-button type="primary" size="small" @click="changeAuth(scope.row)">方法权限</el-button>
					<el-button type="danger" size="small">禁用</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog title="权限列表" :visible.sync="authTreeShow" width="70%" style="text-align: left;" :close-on-click-modal="false">
			<el-tree
				ref="auth"
				:data="authList"
				show-checkbox
				node-key="id"
				:default-expanded-keys="openedKeys"
				:default-checked-keys="[]"
				:props="defaultProps"
				style="max-height: 80vh;overflow: scroll;min-height: 60vh;"
			></el-tree>
			<span slot="footer" class="dialog-footer">
				<el-button @click="authTreeShow = false">取 消</el-button>
				<el-button type="primary" @click="getCheckedNodes('auth')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="菜单列表" :visible.sync="menuTreeShow" width="70%" style="text-align: left;" :close-on-click-modal="false">
			<el-tree
				ref="menu"
				:data="menuList"
				show-checkbox
				node-key="id"
				:default-expanded-keys="menuOpenedKeys"
				:default-checked-keys="[]"
				:props="defaultProps"
				style="max-height: 80vh;overflow: scroll;min-height: 60vh;"
			></el-tree>
			<span slot="footer" class="dialog-footer">
				<el-button @click="menuTreeShow = false">取 消</el-button>
				<el-button type="primary" @click="getCheckedNodes('menu')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="添加管理员组" :visible.sync="addDialogShow" width="70%" :close-on-click-modal="false">
			<div style="text-align: left;min-height: 60vh;max-height: 80vh;">
				<el-row>
					<el-col :span="4"><span style="line-height: 40px;">组名</span></el-col>
					<el-col :span="12"><el-input v-model="addManageGroupInfo.name" placeholder="请输入分组名称"></el-input></el-col>
				</el-row>
				<div class="tree_title">菜单权限</div>
				<el-tree
					ref="addmenu"
					:data="menuList"
					show-checkbox
					node-key="id"
					:default-expanded-keys="menuOpenedKeys"
					:default-checked-keys="[]"
					:props="defaultProps"
					style="overflow: scroll;"
				></el-tree>
				<div class="tree_title">方法权限</div>
				<el-tree
					ref="addauth"
					:data="authList"
					show-checkbox
					node-key="id"
					:default-expanded-keys="openedKeys"
					:default-checked-keys="[]"
					:props="defaultProps"
					style="overflow: scroll;"
				></el-tree>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addDialogShow = false">取 消</el-button>
				<el-button type="primary" @click="addSubmit()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
	name: '',
	data() {
		return {
			manageGroupList: [],
			defaultProps: {
				children: 'children',
				label: 'name'
			},
			authTreeShow: false, //方法权限模态框
			authList: [], //方法权限列表
			openedKeys: [], //方法权限默认展开项id集合
			menuList: [], //菜单列表
			menuTreeShow: false, //菜单列表模态框
			menuOpenedKeys: [], //菜单权限默认展开项id集合
			currentScope: '',
			loading: false,
			addDialogShow: false,
			addManageGroupInfo: {
				name: ''
			}
		};
	},
	mounted() {
		this.getGroupList();
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		getGroupList() {
			this.$axios({
				url: this.HOST + '/admin.setting/manageGroupList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
				}
			})
				.then(res => {
					console.log(res.data);
					this.loading = false;
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.manageGroupList = res.data.groupList;
						this.authList = res.data.authList;
						this.openedKeys = res.data.auth_keys;
						this.menuList = res.data.menuList;
						this.menuOpenedKeys = res.data.menu_keys;
					}
				})
				.catch(error => {
					console.log(error);
					this.loading = false;
				});
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getGroupList();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getGroupList();
		},
		changeAuth(scope) {
			this.currentScope = scope;
			this.authTreeShow = true;
			this.$nextTick(() => {
				// 初始化树形控件选中状态
				this.$refs.auth.setCheckedKeys(scope.auth_list, false);
			});
		},
		changeMenu(scope) {
			this.currentScope = scope;
			this.menuTreeShow = true;
			this.$nextTick(() => {
				// 初始化树形控件选中状态
				this.$refs.menu.setCheckedKeys(scope.menu_list, false);
			});
		},
		getCheckedNodes(refName) {
			this.$confirm('确认修改当前管理员权限信息吗？')
				.then(() => {
					this.loading = true;
					let arr = this.$refs[refName].getCheckedNodes();
					let newArr = [];
					for (let i in arr) {
						if (!arr[i].children) {
							newArr.push(arr[i].id);
						}
					}
					this.currentScope[refName + '_list'] = newArr;
					this.$axios({
						url: this.HOST + '/admin.setting/changeManageGroup',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							id: this.currentScope.id,
							auth_list: this.currentScope.auth_list,
							menu_list: this.currentScope.menu_list
						}
					})
						.then(res => {
							this.loading = false;
							if (res.data.status == 1) {
								this.$message.success(res.data.msg);
								this[refName + 'TreeShow'] = false;
							} else {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							}
						})
						.catch(err => {
							this.loading = false;
						});
				})
				.catch(() => {
					console.log('手动放弃修改');
				});
		},
		addManageGroup() {
			this.addManageGroupInfo.name = '';
			this.addDialogShow = true;
			this.$nextTick(() => {
				// 初始化树形控件选中状态
				this.$refs.addauth.setCheckedKeys([], false);
				this.$refs.addmenu.setCheckedKeys([], false);
			});
		},
		addSubmit() {
			this.$confirm('确认信息无误并提交？')
				.then(() => {
					this.loading = true;
					let list = ['menu', 'auth'];
					for (let i in list) {
						let arr = this.$refs['add' + list[i]].getCheckedNodes();
						let newArr = [];
						for (let i in arr) {
							if (!arr[i].children) {
								newArr.push(arr[i].id);
							}
						}
						this.addManageGroupInfo[list[i] + '_list'] = newArr;
					}
					console.log(this.addManageGroupInfo);
					this.$axios({
						url: this.HOST + '/admin.setting/addManageGroup',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							manageInfo: this.addManageGroupInfo
						}
					})
						.then(res => {
							this.loading = false;
							if (res.data.status == 1) {
								this.$message.success(res.data.msg);
								this.addDialogShow = false;
								this.getGroupList();
							} else {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							}
						})
						.catch(err => {
							this.loading = false;
						});
				})
				.catch(() => {
					console.log('手动放弃修改');
				});
		}
	}
};
</script>
<style>
.el-tree-node.is-expanded > .el-tree-node__children {
	display: flex;
	flex-flow: row wrap;
}
.tree_title{
	font-size: 16px;
	font-weight: bold;
	margin: 10px 0;
	color: #23baff;
}
</style>
